var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('role-form',{attrs:{"role":_vm.role,"validations":_vm.validations,"title":_vm.$t('label.newRole')},on:{"submit":_vm.onSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }